import React from 'react';
import H1 from 'components/H1';
import { Box, Button, Heading } from 'rebass';
import { Input, Label } from '@rebass/forms';
import services from 'services/services';
import { useToasts } from 'react-toast-notifications';

export default function CreateParticipant(props) {
    const { addToast } = useToasts();

    function onSubmit(e) {
        e.preventDefault();

        const first_name_values = document.getElementsByName('create_person_first_name');
        const last_name_values = document.getElementsByName('create_person_last_name');
        const email_values = document.getElementsByName('create_person_email');

        const person = {
            first_name: first_name_values[0].value,
            last_name: last_name_values[0].value,
            email: email_values[0].value
        };

        if (props.study_id) {
            services
                .addPersonToStudy(props.study_id, person)
                .then(study_person_xhr => {
                    props.onClose();
                    props.onCreate(study_person_xhr);
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);
                    addToast(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        } else {
            services
                .createPerson(person)
                .then(person_xhr => {
                    props.onClose();
                    props.onCreate(person_xhr);
                })
                .catch(error => {
                    const errorText = services.parseXhrErrors(error);

                    addToast(errorText, {
                        appearance: 'error',
                        autoDismiss: true
                    });
                });
        }
    }

    return (
        <form onSubmit={onSubmit}>
            <Box>
                <Label>First Name</Label>
                <Input
                    type="text"
                    name="create_person_first_name"
                    placeholder="John"
                    autoComplete="off"
                    required
                    autoFocus
                    />
                <Label mt={3}>Last Name</Label>
                <Input
                    type="text"
                    name="create_person_last_name"
                    placeholder="Smith"
                    autoComplete="off"
                    required />
                <Label mt={3}>Email</Label>
                <Input
                    type="text"
                    name="create_person_email"
                    placeholder="jsmith@gmail.com"
                    autoComplete="off"
                    required />
            </Box>
            <Box className='modal-actions'>
                <Button variant="secondary-gray" type="button" mr={3} onClick={props.onClose}>
                    Cancel
                </Button>
                <Button type="submit" variant="primary" mr={0} className="modal-primary">
                    Create panelist
                </Button>
            </Box>
        </form>
    );
}
